import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {connect} from "react-redux";
import {Redirect, withRouter} from "react-router-dom";

import FieldGroup from "../FieldGroup";
import {adminLogin} from "../../redux/actions";

class LoginForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
        this.usernameChanged = this.usernameChanged.bind(this);
        this.passwordChanged = this.passwordChanged.bind(this);

        this.state = {
            username: "",
            password: ""
        };
    }

    handleClick(e) {
        e.preventDefault();
        this.setState({isLoggingIn: true});
        this.props.dispatch(adminLogin({username: this.state.username, password: this.state.password}));
    }

    usernameChanged(e) {
        this.setState({username: e.target.value});
    }

    passwordChanged(e) {
        this.setState({password: e.target.value});
    }

    render() {
        const {referrer} = this.props.location.state || {referrer: "/"};
        return this.props.loggedIn ? (
            <Redirect to={referrer} />
        ) : (
            <Row className="show-grid">
                <Col xsHidden={true} smHidden={true} md={3} lg={4}/>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <form>
                        <h2>Admin login</h2>
                        <FieldGroup
                            autoComplete="username"
                            id="username"
                            type="text"
                            label="Username"
                            onChange={this.usernameChanged}
                            placeholder="Enter username"
                        />
                        <FieldGroup
                            autoComplete="current-password"
                            id="password"
                            type="password"
                            label="Password"
                            onChange={this.passwordChanged}
                            placeholder="Enter password"
                        />
                        <Button block={true} disabled={this.props.pendingCalls > 0} onClick={this.handleClick}
                                bsStyle="primary" type="submit">Login</Button>
                    </form>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => {
    return {loggedIn: state.loggedIn, pendingCalls: state.pendingCalls};
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));


// WEBPACK FOOTER //
// ./src/components/admin/LoginForm.js